import React from 'react'
import styled from 'styled-components/macro'

const OrderSummary = ({
  grandTotal,
  goodsTotal = 0,
  deliveryTotal = 0,
  totalSuppliers,
  totalItems,
  totalUnits,
  isRefetching,
}) => {
  return (
    <SummaryContainer>
      <SummaryItem>
        <Label>Goods (ex VAT):</Label>
        <Value>
          {isRefetching ? 'Updating…' : `£${goodsTotal.toFixed(2)}`}
        </Value>
      </SummaryItem>
      <SummaryItem>
        <Label>Delivery (ex VAT):</Label>
        <Value>
          {isRefetching ? 'Updating…' : `£${deliveryTotal.toFixed(2)}`}
        </Value>
      </SummaryItem>
      <SummaryItem>
        <Label>Order total (ex VAT):</Label>
        <Value $isRefetching={isRefetching}>
          {isRefetching ? 'Updating…' : `£${parseFloat(grandTotal).toFixed(2)}`}
        </Value>
      </SummaryItem>
      <SummaryItem>
        <Label>Suppliers:</Label>
        <Value $isRefetching={isRefetching}>{totalSuppliers}</Value>
      </SummaryItem>
      <SummaryItem>
        <Label>Products:</Label>
        <Value $isRefetching={isRefetching}>{totalItems}</Value>
      </SummaryItem>
      {totalUnits != null ? (
        <SummaryItem>
          <Label>Units:</Label>
          <Value $isRefetching={isRefetching}>{totalUnits}</Value>
        </SummaryItem>
      ) : null}
    </SummaryContainer>
  )
}

const SummaryContainer = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  align-items: center;
`

const SummaryItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`

const Label = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.colours.mayoWhite};
  opacity: 0.9;
`

const Value = styled.span`
  font-size: 18px;
  font-weight: 700;
  color: ${({ theme }) => theme.colours.mayoWhite};
  opacity: ${props => (props.$isRefetching ? 0.5 : 1)};
  transition: opacity 0.2s ease;
`

export default OrderSummary
